import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CountryCity } from "../_types/country-city";
@Injectable({
  providedIn: 'root',
})

export class CountriesCitiesService extends Service<CountryCity> {
  public override type = 'countriesCities';
  public override url = 'common/countriesCities';
}
